module.exports = __webpack_public_path__ + "media/images/our_apps/roku_mobile-9d976832930537e9a94df24b59aef9a5.png";